import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { uniqueId } from '@/utils/misc';
import {
  maxLength,
  required,
  withLocalizedValidators,
} from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeToDiscarded',
  emits: ["confirmDiscarded", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'confirmDiscarded', value: string): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();



const componentId = uniqueId();

const state = reactive({ discardedReason: '' });

const validations = {
  discardedReason: withLocalizedValidators(
    'e_service_center.alert_workflow_details.discarded_reason',
    {
      required,
      maxLength: maxLength(250),
    },
  ),
};

const v$ = useVuelidate(validations, state);

function onSubmit() {
  emit('confirmDiscarded', state.discardedReason);
  emit('close');
}

const validationMessage = computed(
  () => v$.value.discardedReason?.$errors[0]?.$message,
);

return { __sfc: true,t, emit, componentId, state, validations, v$, onSubmit, validationMessage }
}

})